import React, { FC, PropsWithChildren } from "react";

import { t } from "i18next";
import { IconButton } from "@mui/material";

import { ModalDialogBody, ModalDialogHeader, ModalDialogTitle, StyledCross, StyledModal } from "./styled";

type ModalDialogProps = {
    open: boolean;
    title: string;
    fullSize?: boolean;
    onClose: () => void;
    showClose?: boolean;
};

const ModalDialog: FC<PropsWithChildren<ModalDialogProps>> = ({
    children,
    open,
    title,
    fullSize = false,
    onClose,
    showClose = true,
}) => {
    return (
        <StyledModal open={open} onClose={onClose}>
            <div>
                <ModalDialogHeader>
                    <ModalDialogTitle>{title}</ModalDialogTitle>
                    {showClose && (
                        <IconButton onClick={onClose} aria-label={t("Common.Close")}>
                            <StyledCross className="modalDialogCloseIcon" data-testid="modal_dialog-button-close" />
                        </IconButton>
                    )}
                </ModalDialogHeader>
                <ModalDialogBody $fullSize={fullSize}>{children}</ModalDialogBody>
            </div>
        </StyledModal>
    );
};

export default ModalDialog;
